/* West Hill Wagon Works – Model railway scale calculator
   Shopify theme asset. Place <div id="whww-calc"><\/div> on the page, then load this file after it.
   The calculator renders inside a shadow root, so theme CSS cannot affect it. */
(function () {
  "use strict";
  if (window.__whwwCalcLoaded) { if (window.__whwwBoot) window.__whwwBoot(); return; }
  window.__whwwCalcLoaded = true;

  var FONTS = "https://fonts.googleapis.com/css2?family=Carlito:wght@400;700&family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap";
  var JSPDF = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";

  function ensureFonts() {
    if (document.querySelector("link[data-whww-fonts]")) return;
    var l = document.createElement("link");
    l.rel = "stylesheet"; l.href = FONTS; l.setAttribute("data-whww-fonts", "");
    (document.head || document.documentElement).appendChild(l);
  }

  var jspdfP = null;
  function loadJsPdf() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
    if (!jspdfP) {
      jspdfP = new Promise(function (res, rej) {
        var amd = window.define && window.define.amd ? window.define : null;
        if (amd) window.define = undefined; // make the library expose window.jspdf even if the theme uses an AMD loader
        var s = document.createElement("script");
        s.src = JSPDF; s.async = true;
        s.onload = function () { if (amd) window.define = amd; (window.jspdf && window.jspdf.jsPDF) ? res(window.jspdf.jsPDF) : rej(new Error("nopdf")); };
        s.onerror = function () { if (amd) window.define = amd; jspdfP = null; rej(new Error("nopdf")); };
        (document.head || document.documentElement).appendChild(s);
      });
    }
    return jspdfP;
  }

  var PLATE_SVG = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 120' preserveAspectRatio='none'><rect width='800' height='120' fill='#C8102E'/><polygon points='0,0 330,0 230,120 0,120' fill='#A80C26'/><polygon points='0,0 150,0 70,120 0,120' fill='#8E0A20'/><polygon points='540,0 800,0 800,120 440,120' fill='#DA1F38'/><polygon points='690,0 800,0 800,120 610,120' fill='#E8384D'/><polygon points='360,0 380,0 280,120 260,120' fill='#E04257' opacity='.55'/><polygon points='405,0 415,0 315,120 305,120' fill='#E04257' opacity='.4'/><\/svg>";
  var PLATE_URL = "data:image/svg+xml," + encodeURIComponent(PLATE_SVG);

  var CSS = [
    ":host{all:initial;display:block;contain:layout}",
    "*,*::before,*::after{box-sizing:border-box}",
    "[hidden]{display:none!important}",
    ".w-root{--bg:#E9EBE6;--surface:#F8F9F6;--surface-2:#F0F2EC;--ink:#1D221E;--muted:#5B635C;--line:#C9CDC4;--accent:#8A3A20;--accent-ink:#fff;--accent-tint:#F3E3DC;--tag:#E7C64A;--tag-ink:#2A2410;--danger:#A12A1C;--focus:#1F6FB2;",
    "--f-logo:Calibri,Carlito,'Segoe UI',Arial,sans-serif;--f-display:'Barlow Condensed','Arial Narrow',sans-serif;--f-body:'IBM Plex Sans',system-ui,-apple-system,'Segoe UI',Arial,sans-serif;--f-mono:'IBM Plex Mono',ui-monospace,Menlo,Consolas,monospace;--r:6px;",
    "background:var(--bg);color:var(--ink);font-family:var(--f-body);font-size:15px;font-weight:400;line-height:1.5;letter-spacing:normal;text-align:left;border-radius:var(--r);padding:16px;max-width:900px;margin:0 auto;display:grid;gap:18px;color-scheme:light;-webkit-text-size-adjust:100%}",
    "h1,h2,h3,p,ol,li{margin:0;padding:0;font:inherit;color:inherit;letter-spacing:normal}",
    "button,input,select,textarea{font-family:inherit;font-size:inherit;color:inherit;letter-spacing:normal;margin:0}",
    "button{-webkit-appearance:none;appearance:none}",
    ":focus-visible{outline:2px solid var(--focus);outline-offset:2px}",
    ".w-plate{background:#C8102E url(\"" + PLATE_URL + "\") center/100% 100% no-repeat;color:#fff;border-radius:var(--r);padding:18px 22px;display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:8px 20px;position:relative}",
    ".w-plate::before,.w-plate::after{content:'';position:absolute;top:50%;width:8px;height:8px;margin-top:-4px;border-radius:50%;background:rgba(255,255,255,.35)}",
    ".w-plate::before{left:8px}.w-plate::after{right:8px}",
    ".w-brand{font-family:var(--f-logo);font-weight:700;font-size:clamp(24px,5.5vw,36px);letter-spacing:.02em;line-height:1;color:#fff;text-shadow:0 1px 2px rgba(60,0,10,.35)}",
    ".w-sub{font-family:var(--f-display);font-weight:600;font-size:17px;letter-spacing:.06em;text-transform:uppercase;color:#fff;opacity:.92;line-height:1.2}",
    ".w-panel{background:var(--surface);border:1px solid var(--line);border-radius:var(--r);padding:20px;display:grid;gap:22px}",
    ".w-step{display:grid;gap:10px}",
    ".w-label{font-family:var(--f-display);font-weight:600;font-size:14px;letter-spacing:.08em;text-transform:uppercase;color:var(--muted);line-height:1.3}",
    ".w-scales{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}",
    ".w-scale{text-align:left;cursor:pointer;background:var(--surface-2);border:1.5px solid var(--line);border-radius:var(--r);padding:10px 12px;display:grid;gap:2px;line-height:1.35}",
    ".w-scale:hover{border-color:var(--muted)}",
    ".w-scale[aria-pressed='true']{border-color:var(--accent);background:var(--accent-tint)}",
    ".w-scale .nm{font-family:var(--f-display);font-weight:700;font-size:23px;line-height:1.1}",
    ".w-scale .rt{font-family:var(--f-mono);font-size:13px}",
    ".w-scale .sp{font-size:12px;color:var(--muted)}",
    ".w-nv{display:flex;flex-wrap:wrap;align-items:center;gap:8px;font-size:13px;color:var(--muted)}",
    ".w-seg{display:inline-flex;flex-wrap:wrap;border:1.5px solid var(--line);border-radius:var(--r);overflow:hidden;background:var(--surface-2);max-width:100%;justify-self:start}",
    ".w-seg button{border:0;background:transparent;padding:9px 14px;cursor:pointer;font-weight:500}",
    ".w-seg button[aria-pressed='true']{background:var(--accent);color:var(--accent-ink)}",
    ".w-seg.sm button{padding:5px 10px;font-size:13px}",
    ".w-row{display:flex;flex-wrap:wrap;gap:8px;align-items:stretch}",
    ".w-field{display:grid;gap:4px;min-width:0;align-content:start}",
    ".w-field label{font-size:12px;color:var(--muted)}",
    "input[type='text'],select{background:var(--surface);border:1.5px solid var(--line);border-radius:var(--r);padding:10px 12px;min-height:46px;line-height:1.3;max-width:100%}",
    "input:focus,select:focus{border-color:var(--accent);outline:none;box-shadow:0 0 0 3px var(--accent-tint)}",
    ".w-num{font-family:var(--f-mono);font-size:17px;width:9.5em}",
    ".w-num.sm{width:6.5em}",
    ".w-grow{flex:1 1 220px}.w-grow input{width:100%}",
    ".w-err{color:var(--danger);font-size:13px}",
    ".w-result{border-top:2px dashed var(--line);padding-top:18px;display:grid;gap:14px}",
    ".w-top{display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:12px 20px}",
    ".w-main{min-width:0}",
    ".w-eq{font-size:13px;color:var(--muted);margin-bottom:2px}",
    ".w-val{font-family:var(--f-display);font-weight:700;font-size:clamp(36px,9vw,54px);line-height:1;font-variant-numeric:tabular-nums;overflow-wrap:anywhere}",
    ".w-also{font-family:var(--f-mono);font-size:14px;color:var(--muted);margin-top:6px;overflow-wrap:anywhere}",
    ".w-others{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:6px;margin-top:6px}",
    ".w-other{background:var(--surface-2);border:1px solid var(--line);border-radius:var(--r);padding:7px 10px;text-align:left;cursor:pointer;min-width:0;line-height:1.35}",
    ".w-other:hover{border-color:var(--muted)}",
    ".w-other[aria-current='true']{border-color:var(--accent)}",
    ".w-other .k{font-family:var(--f-display);font-weight:600;font-size:15px;letter-spacing:.04em}",
    ".w-other .v{display:block;font-family:var(--f-mono);font-size:13px;overflow-wrap:anywhere}",
    ".w-save{display:flex;flex-wrap:wrap;gap:8px;align-items:flex-end}",
    ".w-btn{border:1.5px solid var(--line);background:var(--surface-2);border-radius:var(--r);padding:10px 16px;min-height:46px;cursor:pointer;font-weight:600;line-height:1.2}",
    ".w-btn:hover{border-color:var(--muted)}",
    ".w-btn.primary{background:var(--accent);border-color:var(--accent);color:var(--accent-ink)}",
    ".w-btn.q{min-height:38px;padding:7px 12px;font-weight:500;font-size:13px}",
    ".w-btn.warn{color:var(--danger)}",
    ".w-btn:disabled{opacity:.5;cursor:not-allowed}",
    ".w-ledger{background:var(--surface);border:1px solid var(--line);border-radius:var(--r)}",
    ".w-lh{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:10px;padding:14px 16px;border-bottom:1px solid var(--line)}",
    ".w-lh h2{font-family:var(--f-display);font-weight:700;font-size:21px;letter-spacing:.03em;text-transform:uppercase;line-height:1.2}",
    ".w-count{font-family:var(--f-mono);font-size:13px;color:var(--muted);margin-left:6px;font-weight:400}",
    ".w-acts{display:flex;flex-wrap:wrap;gap:6px;align-items:center}",
    ".w-entries{list-style:none;margin:0;padding:0}",
    ".w-entry{display:grid;grid-template-columns:2em minmax(0,1fr) auto auto;gap:4px 12px;align-items:center;padding:12px 16px;border-bottom:1px solid var(--line)}",
    ".w-entry:last-child{border-bottom:0}",
    ".w-entry .no{font-family:var(--f-mono);color:var(--muted);font-size:13px}",
    ".w-entry .what{min-width:0}",
    ".w-entry .ttl{font-weight:600;overflow-wrap:anywhere}",
    ".w-entry .meta{font-size:13px;color:var(--muted);overflow-wrap:anywhere}",
    ".w-entry .ans{text-align:right;font-family:var(--f-mono);font-weight:500;font-variant-numeric:tabular-nums}",
    ".w-entry .ans small{display:block;color:var(--muted);font-weight:400;font-size:12px}",
    ".w-tag{display:inline-block;background:var(--tag);color:var(--tag-ink);font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;padding:1px 6px;border-radius:3px;margin-left:6px;vertical-align:2px}",
    ".w-del{border:0;background:transparent;cursor:pointer;color:var(--muted);width:36px;height:36px;padding:0;border-radius:var(--r);font-size:18px;line-height:1}",
    ".w-del:hover{color:var(--danger);background:var(--surface-2)}",
    ".w-empty{padding:24px 16px;color:var(--muted)}",
    ".w-copybox{padding:0 16px 16px}",
    ".w-copybox textarea{width:100%;min-height:120px;font-family:var(--f-mono);font-size:13px;background:var(--surface-2);border:1px solid var(--line);border-radius:var(--r);padding:8px}",
    ".w-toast{font-size:13px;color:var(--muted);min-height:1.2em}",
    ".w-foot{font-size:12px;color:var(--muted)}",
    "@media (max-width:620px){.w-scales,.w-others{grid-template-columns:repeat(2,minmax(0,1fr))}}",
    "@media (max-width:520px){.w-entry{grid-template-columns:1.6em minmax(0,1fr) auto}.w-entry .ans{grid-column:2;text-align:left}.w-entry .w-del{grid-column:3;grid-row:1/span 2}}"
  ].join("");

  var HTML = [
    "<div class='w-root'>",
    "<header class='w-plate'><h1 class='w-brand'>WEST HILL WAGON WORKS<\/h1><p class='w-sub'>Model railway scale calculator<\/p><\/header>",
    "<div class='w-panel'>",
    "<section class='w-step'><h3 class='w-label' id='l-scale'>1 · Choose your scale<\/h3>",
    "<div class='w-scales' id='scales' role='group' aria-labelledby='l-scale'><\/div>",
    "<div class='w-nv' id='nvariant' hidden><span>N gauge ratio:<\/span><div class='w-seg sm' role='group' aria-label='N gauge ratio'>",
    "<button type='button' id='n148' data-n='148'>1:148 British<\/button><button type='button' id='n160' data-n='160'>1:160 Continental / US<\/button><\/div><\/div><\/section>",
    "<section class='w-step'><h3 class='w-label' id='l-dir'>2 · What are you converting?<\/h3>",
    "<div class='w-seg' role='group' aria-labelledby='l-dir'><button type='button' id='r2m' data-dir='r2m'>Real size → Model<\/button><button type='button' id='m2r' data-dir='m2r'>Model → Real size<\/button><\/div><\/section>",
    "<section class='w-step'><h3 class='w-label'>3 · Enter a measurement<\/h3>",
    "<form class='w-row' id='form' autocomplete='off'>",
    "<div class='w-field'><label for='v1' id='v1lab'>Length<\/label><input class='w-num' id='v1' inputmode='decimal' type='text' placeholder='0'><\/div>",
    "<div class='w-field' id='v2wrap' hidden><label for='v2'>Inches<\/label><input class='w-num sm' id='v2' inputmode='decimal' type='text' placeholder='0'><\/div>",
    "<div class='w-field'><label for='inunit'>Unit<\/label><select id='inunit'><\/select><\/div><\/form>",
    "<p class='w-err' id='err' hidden><\/p><\/section>",
    "<section class='w-result' aria-live='polite'><div class='w-top'><div class='w-main'>",
    "<p class='w-eq' id='reseq'>—<\/p><p class='w-val' id='resval'>—<\/p><p class='w-also' id='resalso'><\/p><\/div>",
    "<div class='w-field'><label for='outunit'>Show answer in<\/label><select id='outunit'><\/select><\/div><\/div>",
    "<div><h3 class='w-label' id='otherslab'>Same measurement in other scales<\/h3><div class='w-others' id='others'><\/div><\/div>",
    "<div class='w-save'><div class='w-field w-grow'><label for='name'>Name this measurement (optional)<\/label><input type='text' id='name' placeholder='e.g. Brake van body length'><\/div>",
    "<button type='button' class='w-btn primary' id='save'>Add to list<\/button><\/div><\/section>",
    "<\/div>",
    "<section class='w-ledger'><div class='w-lh'><h2>Saved measurements<span class='w-count' id='count'><\/span><\/h2>",
    "<div class='w-acts'><span class='w-toast' id='toast' role='status'><\/span>",
    "<button type='button' class='w-btn q' id='pdf'>Save as PDF<\/button><button type='button' class='w-btn q' id='print'>Print list<\/button>",
    "<button type='button' class='w-btn q' id='copy'>Copy list<\/button><button type='button' class='w-btn q warn' id='clear'>Clear all<\/button><\/div><\/div>",
    "<ol class='w-entries' id='entries'><\/ol>",
    "<p class='w-empty' id='empty' hidden>Nothing saved yet. Enter a measurement above and press <strong>Add to list<\/strong> (or Enter) to build up a list.<\/p>",
    "<div class='w-copybox' id='copybox' hidden><label class='w-label' for='copytext' style='display:block;margin-bottom:6px'>Your list as text. Select it and copy.<\/label><textarea id='copytext' readonly><\/textarea><\/div>",
    "<\/section>",
    "<p class='w-foot'>Ratios used: N 1:148 (British, 2.06 mm/ft) or 1:160 · TT:120 1:120 (2.54 mm/ft) · OO 1:76.2 (4 mm/ft) · O 1:43.5 (7 mm/ft). Your saved list stays in this browser on this device.<\/p>",
    "<\/div>"
  ].join("");

  /* ---------- Shared data and maths ---------- */
  var SCALES = {
    N:  { name: "N", track: "9 mm" },
    TT: { name: "TT:120", track: "12 mm", ratio: 120 },
    OO: { name: "OO", track: "16.5 mm", ratio: 76.2 },
    O:  { name: "O", track: "32 mm", ratio: 43.5 }
  };
  var ORDER = ["N", "TT", "OO", "O"];
  var MM = { mm: 1, cm: 10, m: 1000, km: 1e6, "in": 25.4, ft: 304.8, yd: 914.4, mi: 1609344 };
  var UNIT_LABEL = { mm: "mm", cm: "cm", m: "metres", km: "km", "in": "inches", ft: "feet", ftin: "feet + inches", yd: "yards", mi: "miles" };
  var IN_UNITS  = { r2m: ["m", "cm", "mm", "km", "ftin", "ft", "in", "yd", "mi"], m2r: ["mm", "cm", "m", "in", "ft"] };
  var OUT_UNITS = { r2m: ["mm", "cm", "m", "in", "ftin"], m2r: ["m", "cm", "mm", "km", "ftin", "ft", "in", "yd", "mi"] };
  var DEFAULT_OUT = { r2m: "mm", m2r: "ftin" };
  var DEFAULT_IN  = { r2m: "m", m2r: "mm" };
  var STORE = "whww-scale-calc-v1";

  function trim(n, dp) { return Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0, maximumFractionDigits: dp }); }
  function smartDp(v) { var a = Math.abs(v); return a >= 1000 ? 0 : a >= 100 ? 1 : a >= 10 ? 2 : 3; }
  function ftIn(mm) {
    var t = mm / 25.4, ft = Math.floor(t / 12), inch = Math.round((t - ft * 12) * 10) / 10;
    if (inch >= 12) { ft += 1; inch = 0; }
    return ft === 0 ? trim(inch, 1) + " in" : trim(ft, 0) + " ft " + trim(inch, 1) + " in";
  }
  function inFraction(mm) {
    var s = Math.round(mm / 25.4 * 16), whole = Math.floor(s / 16), rem = s % 16, den = 16;
    if (rem === 0) return whole + " in";
    while (rem % 2 === 0) { rem /= 2; den /= 2; }
    return (whole ? whole + " " : "") + rem + "/" + den + " in";
  }
  function fmt(mm, unit) {
    if (unit === "ftin") return ftIn(mm);
    var v = mm / MM[unit];
    var dp = unit === "mm" ? (Math.abs(v) >= 100 ? 1 : 2) : smartDp(v);
    return trim(v, dp) + " " + (unit === "mi" ? "miles" : unit);
  }
  function parseNum(s) {
    s = String(s || "").trim().replace(/,/g, ".").replace(/\s+/g, "");
    if (s === "") return { empty: true };
    if (!/^\d*\.?\d+$|^\d+\.$/.test(s)) return { bad: true };
    return { v: parseFloat(s) };
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function today() { return new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }); }

  /* ---------- One calculator instance ---------- */
  function init(host) {
    if (host.__whww || !host.attachShadow) return;
    host.__whww = true;
    host.innerHTML = "";
    var root = host.attachShadow({ mode: "open" });
    root.innerHTML = "<style>" + CSS + "<\/style>" + HTML;
    function $(id) { return root.getElementById(id); }

    var state = { scale: "OO", n: 148, dir: "r2m", inUnit: "m", outUnit: "mm", list: null };
    function load() { try { var raw = localStorage.getItem(STORE); return raw ? JSON.parse(raw) : null; } catch (e) { return null; } }
    function persist() {
      try { localStorage.setItem(STORE, JSON.stringify({ scale: state.scale, n: state.n, dir: state.dir, inUnit: state.inUnit, outUnit: state.outUnit, list: state.list })); } catch (e) {}
    }
    function ratioOf(k) { return k === "N" ? state.n : SCALES[k].ratio; }
    function scaleLabel(k) { return SCALES[k].name + " 1:" + ratioOf(k); }

    var el = {};
    ["scales", "nvariant", "n148", "n160", "r2m", "m2r", "v1", "v2", "v1lab", "v2wrap", "inunit", "outunit", "err", "reseq", "resval", "resalso",
     "others", "otherslab", "name", "save", "entries", "empty", "count", "copy", "clear", "toast", "copybox", "copytext", "pdf", "print", "form"]
      .forEach(function (k) { el[k] = $(k); });

    function renderScales() {
      el.scales.innerHTML = "";
      ORDER.forEach(function (k) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "w-scale";
        b.setAttribute("aria-pressed", String(k === state.scale));
        b.innerHTML = "<span class='nm'>" + SCALES[k].name + "<\/span><span class='rt'>1:" + ratioOf(k) + " · " + trim(304.8 / ratioOf(k), 2) +
          " mm/ft<\/span><span class='sp'>" + SCALES[k].track + " track gauge<\/span>";
        b.addEventListener("click", function () { state.scale = k; persist(); renderScales(); calc(); });
        el.scales.appendChild(b);
      });
      el.nvariant.hidden = state.scale !== "N";
      el.n148.setAttribute("aria-pressed", String(state.n === 148));
      el.n160.setAttribute("aria-pressed", String(state.n === 160));
    }
    function fillSelect(sel, units, value) {
      sel.innerHTML = "";
      units.forEach(function (u) { var o = document.createElement("option"); o.value = u; o.textContent = UNIT_LABEL[u]; if (u === value) o.selected = true; sel.appendChild(o); });
    }
    function renderDir() {
      el.r2m.setAttribute("aria-pressed", String(state.dir === "r2m"));
      el.m2r.setAttribute("aria-pressed", String(state.dir === "m2r"));
      if (IN_UNITS[state.dir].indexOf(state.inUnit) < 0) state.inUnit = DEFAULT_IN[state.dir];
      if (OUT_UNITS[state.dir].indexOf(state.outUnit) < 0) state.outUnit = DEFAULT_OUT[state.dir];
      fillSelect(el.inunit, IN_UNITS[state.dir], state.inUnit);
      fillSelect(el.outunit, OUT_UNITS[state.dir], state.outUnit);
      el.otherslab.textContent = state.dir === "r2m" ? "Model size in every scale" : "Real size if built in another scale";
      renderInputs();
    }
    function renderInputs() {
      var ftin = state.inUnit === "ftin";
      el.v2wrap.hidden = !ftin;
      el.v1lab.textContent = ftin ? "Feet" : (state.dir === "r2m" ? "Real length" : "Model length");
    }

    var current = null;
    function readInputMm() {
      var a = parseNum(el.v1.value);
      if (state.inUnit === "ftin") {
        var b = parseNum(el.v2.value);
        if (a.bad || b.bad) return { bad: true };
        if (a.empty && b.empty) return { empty: true };
        var ft = a.empty ? 0 : a.v, inch = b.empty ? 0 : b.v;
        return { mm: ft * 304.8 + inch * 25.4, text: (ft ? trim(ft, 3) + " ft " : "") + trim(inch, 3) + " in" };
      }
      if (a.empty) return { empty: true };
      if (a.bad) return { bad: true };
      return { mm: a.v * MM[state.inUnit], text: trim(a.v, 4) + " " + (state.inUnit === "mi" ? "miles" : state.inUnit) };
    }
    function convert(mm, k) { var r = ratioOf(k); return state.dir === "r2m" ? mm / r : mm * r; }
    function alsoLine(mm) {
      var parts;
      if (state.dir === "r2m") {
        parts = ["mm", "cm", "in"].filter(function (u) { return u !== state.outUnit; }).map(function (u) { return fmt(mm, u); });
        parts.push("≈ " + inFraction(mm));
      } else {
        var pick = ["m", "ftin"];
        if (mm >= 1e6) pick.push("km", "mi");
        parts = pick.filter(function (u) { return u !== state.outUnit; }).map(function (u) { return fmt(mm, u); });
      }
      return parts.join("  ·  ");
    }
    function calc() {
      var inp = readInputMm();
      el.err.hidden = true;
      if (inp.bad) { el.err.textContent = "Use numbers only, for example 12.5. Commas are read as decimal points."; el.err.hidden = false; }
      if (inp.empty || inp.bad) {
        current = null;
        el.reseq.textContent = "Enter a measurement to see the " + (state.dir === "r2m" ? "model size" : "real size") + ".";
        el.resval.textContent = "—"; el.resalso.textContent = ""; el.others.innerHTML = ""; el.save.disabled = true;
        return;
      }
      var out = convert(inp.mm, state.scale);
      el.reseq.textContent = (state.dir === "r2m" ? "Real " : "Model ") + inp.text + " in " + scaleLabel(state.scale) + " =";
      el.resval.textContent = fmt(out, state.outUnit);
      el.resalso.textContent = alsoLine(out);
      el.save.disabled = false;
      el.others.innerHTML = "";
      ORDER.forEach(function (k) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "w-other";
        b.setAttribute("aria-current", String(k === state.scale));
        b.title = "Switch to " + SCALES[k].name;
        b.innerHTML = "<span class='k'>" + SCALES[k].name + "<\/span><span class='v'>" + fmt(convert(inp.mm, k), state.outUnit) + "<\/span>";
        b.addEventListener("click", function () { state.scale = k; persist(); renderScales(); calc(); });
        el.others.appendChild(b);
      });
      current = { inText: inp.text, outText: fmt(out, state.outUnit) };
    }

    function renderList() {
      var L = state.list;
      el.entries.innerHTML = "";
      L.forEach(function (e, i) {
        var li = document.createElement("li");
        li.className = "w-entry";
        li.innerHTML = "<span class='no'>" + (i + 1) + "<\/span>" +
          "<div class='what'><div class='ttl'>" + esc(e.label || "Untitled measurement") + (e.example ? "<span class='w-tag'>Example<\/span>" : "") + "<\/div>" +
          "<div class='meta'>" + esc((e.dir === "r2m" ? "Real " : "Model ") + e.inText + " · " + e.scaleText) + "<\/div><\/div>" +
          "<div class='ans'>" + esc(e.outText) + "<small>" + (e.dir === "r2m" ? "model" : "real") + "<\/small><\/div>" +
          "<button type='button' class='w-del' aria-label='Remove " + esc(e.label || "measurement " + (i + 1)) + "'>×<\/button>";
        li.querySelector(".w-del").addEventListener("click", function () { state.list.splice(i, 1); persist(); renderList(); flash("Removed"); });
        el.entries.appendChild(li);
      });
      el.empty.hidden = L.length > 0;
      el.count.textContent = L.length ? "(" + L.length + ")" : "";
      el.copy.disabled = el.clear.disabled = el.pdf.disabled = el.print.disabled = L.length === 0;
      el.copybox.hidden = true;
      resetClear();
    }
    function addCurrent() {
      calc();
      if (!current) { el.v1.focus(); return; }
      state.list.push({ id: Date.now(), label: el.name.value.trim(), dir: state.dir, inText: current.inText, outText: current.outText, scaleText: scaleLabel(state.scale) });
      persist(); renderList(); flash("Added #" + state.list.length);
      el.name.value = ""; el.v1.value = ""; el.v2.value = "";
      calc(); el.v1.focus();
    }
    var toastT;
    function flash(msg, ms) { el.toast.textContent = msg; clearTimeout(toastT); toastT = setTimeout(function () { el.toast.textContent = ""; }, ms || 2200); }

    function listText() {
      return ["West Hill Wagon Works – saved measurements"].concat(state.list.map(function (e, i) {
        return (i + 1) + ". " + (e.label || "Untitled") + ": " + (e.dir === "r2m" ? "real " : "model ") + e.inText + " → " + e.outText + (e.dir === "r2m" ? " model" : " real") + " (" + e.scaleText + ")";
      })).join("\n");
    }
    el.copy.addEventListener("click", function () {
      var t = listText();
      function fallback() { el.copybox.hidden = false; el.copytext.value = t; el.copytext.focus(); el.copytext.select(); flash("Select the text below and copy"); }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(function () { flash("List copied"); }, fallback);
        else fallback();
      } catch (e) { fallback(); }
    });
    var clearArmed = false, clearT;
    function resetClear() { clearArmed = false; el.clear.textContent = "Clear all"; clearTimeout(clearT); }
    el.clear.addEventListener("click", function () {
      if (!clearArmed) { clearArmed = true; el.clear.textContent = "Tap again to clear"; clearT = setTimeout(resetClear, 3500); return; }
      state.list = []; persist(); renderList(); flash("List cleared");
    });

    /* ---------- PDF and print ---------- */
    var PLATE_SHAPES = [
      ["#C8102E", [[0,0],[800,0],[800,120],[0,120]]], ["#A80C26", [[0,0],[330,0],[230,120],[0,120]]],
      ["#8E0A20", [[0,0],[150,0],[70,120],[0,120]]], ["#DA1F38", [[540,0],[800,0],[800,120],[440,120]]],
      ["#E8384D", [[690,0],[800,0],[800,120],[610,120]]], ["#D52E44", [[360,0],[380,0],[280,120],[260,120]]],
      ["#CF2239", [[405,0],[415,0],[315,120],[305,120]]]
    ];
    function rowData(e) {
      return { item: e.label || "Untitled measurement", measured: (e.dir === "r2m" ? "Real " : "Model ") + e.inText, scale: e.scaleText, result: e.outText + (e.dir === "r2m" ? " model" : " real") };
    }
    function pdfSafe(s) {
      return String(s).replace(/→/g, "->").replace(/≈/g, "~").replace(/[–—]/g, "-").replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[^\x00-\xFF]/g, "?");
    }
    function buildPdf(J) {
      var doc = new J({ unit: "mm", format: "a4" });
      var L = 12, R = 198, W = 186, TOP = 12, BAND = 24, date = today();
      function header() {
        PLATE_SHAPES.forEach(function (s) {
          var pts = s[1].map(function (p) { return [L + p[0] / 800 * W, TOP + p[1] / 120 * BAND]; }), d = [];
          for (var i = 1; i < pts.length; i++) d.push([pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]]);
          doc.setFillColor(s[0]); doc.lines(d, pts[0][0], pts[0][1], [1, 1], "F", true);
        });
        doc.setTextColor(255, 255, 255);
        doc.setFont("helvetica", "bold"); doc.setFontSize(21); doc.text("WEST HILL WAGON WORKS", L + 7, TOP + 13);
        doc.setFont("helvetica", "normal"); doc.setFontSize(8.5);
        doc.text("MODEL RAILWAY SCALE CALCULATOR", L + 7, TOP + 19.5);
        doc.text(date, R - 6, TOP + 19.5, { align: "right" });
      }
      var cols = [{ t: "#", x: L + 2, w: 6 }, { t: "Item", x: L + 10, w: 64, k: "item" }, { t: "Measured", x: L + 78, w: 40, k: "measured" },
                  { t: "Scale", x: L + 121, w: 26, k: "scale" }, { t: "Result", x: R - 2, w: 36, k: "result", right: true }];
      function tableHead(y) {
        doc.setFont("helvetica", "bold"); doc.setFontSize(8.5); doc.setTextColor(29, 34, 30);
        cols.forEach(function (c) { doc.text(c.t.toUpperCase(), c.x, y, c.right ? { align: "right" } : undefined); });
        doc.setDrawColor(29, 34, 30); doc.setLineWidth(0.4); doc.line(L, y + 2, R, y + 2);
        return y + 3;
      }
      header();
      doc.setTextColor(29, 34, 30); doc.setFont("helvetica", "bold"); doc.setFontSize(15);
      doc.text("Saved measurements", L, TOP + BAND + 11);
      doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(91, 99, 92);
      doc.text(state.list.length + (state.list.length === 1 ? " item" : " items") + " - " + date, L, TOP + BAND + 16.5);
      var y = tableHead(TOP + BAND + 25);
      doc.setFontSize(10);
      state.list.forEach(function (e, i) {
        var r = rowData(e), lines = {};
        doc.setFont("helvetica", "normal");
        cols.forEach(function (c) { if (c.k) lines[c.k] = doc.splitTextToSize(pdfSafe(r[c.k]), c.w); });
        var n = Math.max(lines.item.length, lines.measured.length, lines.scale.length, lines.result.length), h = n * 4.4 + 3.6;
        if (y + h > 280) { doc.addPage(); header(); y = tableHead(TOP + BAND + 12); doc.setFontSize(10); }
        if (i % 2 === 1) { doc.setFillColor(243, 244, 241); doc.rect(L, y, W, h, "F"); }
        doc.setTextColor(91, 99, 92); doc.setFont("helvetica", "normal"); doc.text(String(i + 1), cols[0].x, y + 5);
        doc.setTextColor(29, 34, 30);
        doc.setFont("helvetica", "bold"); doc.text(lines.item, cols[1].x, y + 5);
        doc.setFont("helvetica", "normal"); doc.text(lines.measured, cols[2].x, y + 5); doc.text(lines.scale, cols[3].x, y + 5);
        doc.setFont("helvetica", "bold"); doc.text(lines.result, cols[4].x, y + 5, { align: "right" });
        y += h;
        doc.setDrawColor(213, 216, 208); doc.setLineWidth(0.2); doc.line(L, y, R, y);
      });
      var pages = doc.getNumberOfPages();
      for (var p = 1; p <= pages; p++) {
        doc.setPage(p); doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(91, 99, 92);
        doc.text("West Hill Wagon Works", L, 289); doc.text("Page " + p + " of " + pages, R, 289, { align: "right" });
      }
      return doc;
    }
    function buildPrintHtml() {
      var date = today();
      var rows = state.list.map(function (e, i) {
        var r = rowData(e);
        return "<tr><td class='n'>" + (i + 1) + "<\/td><td><strong>" + esc(r.item) + "<\/strong><\/td><td>" + esc(r.measured) + "<\/td><td>" + esc(r.scale) + "<\/td><td class='r'><strong>" + esc(r.result) + "<\/strong><\/td><\/tr>";
      }).join("");
      return "<!doctype html><html lang='en-GB'><head><meta charset='utf-8'><title>West Hill Wagon Works - saved measurements<\/title>" +
        "<link rel='stylesheet' href='https://fonts.googleapis.com/css2?family=Carlito:wght@400;700&display=swap'>" +
        "<style>@page{size:A4;margin:14mm}*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}" +
        "body{font-family:Calibri,Carlito,Arial,sans-serif;color:#1d221e;background:#fff;margin:0}" +
        ".plate{background:#C8102E url(\"" + PLATE_URL + "\") center/100% 100% no-repeat;color:#fff;padding:16px 20px;border-radius:4px;display:flex;flex-wrap:wrap;justify-content:space-between;align-items:flex-end;gap:6px 16px}" +
        ".plate h1{margin:0;font-size:26pt;font-weight:700;letter-spacing:.02em;line-height:1}.plate p{margin:0;font-size:10pt;letter-spacing:.08em;text-transform:uppercase}" +
        "h2{font-size:16pt;margin:18px 0 2px}.sub{color:#5b635c;font-size:10.5pt;margin:0 0 10px}" +
        "table{width:100%;border-collapse:collapse;font-size:11pt}thead{display:table-header-group}" +
        "th{text-align:left;border-bottom:1.5px solid #1d221e;padding:6px;font-size:9pt;text-transform:uppercase;letter-spacing:.05em}" +
        "td{padding:6px;border-bottom:1px solid #d5d8d0;vertical-align:top}tr{break-inside:avoid}tbody tr:nth-child(even) td{background:#f3f4f1}" +
        ".r{text-align:right;white-space:nowrap}.n{color:#5b635c;width:2em}.foot{margin-top:14px;color:#5b635c;font-size:9pt}<\/style><\/head><body>" +
        "<header class='plate'><h1>WEST HILL WAGON WORKS<\/h1><p>Model railway scale calculator &middot; " + esc(date) + "<\/p><\/header>" +
        "<h2>Saved measurements<\/h2><p class='sub'>" + state.list.length + (state.list.length === 1 ? " item" : " items") + "<\/p>" +
        "<table><thead><tr><th>#<\/th><th>Item<\/th><th>Measured<\/th><th>Scale<\/th><th class='r'>Result<\/th><\/tr><\/thead><tbody>" + rows + "<\/tbody><\/table>" +
        "<p class='foot'>West Hill Wagon Works<\/p><\/body><\/html>";
    }

    el.pdf.addEventListener("click", function () {
      if (!state.list.length) return;
      el.pdf.disabled = true;
      flash("Making PDF…", 8000);
      loadJsPdf().then(function (J) {
        buildPdf(J).save("West Hill Wagon Works - measurements.pdf");
        flash("PDF downloaded");
      }).catch(function () {
        flash("Couldn't make the PDF. Check your connection and try again.", 4000);
      }).then(function () { el.pdf.disabled = !state.list.length; });
    });
    el.print.addEventListener("click", function () {
      if (!state.list.length) return;
      var f = document.createElement("iframe");
      f.setAttribute("aria-hidden", "true");
      f.setAttribute("tabindex", "-1");
      f.style.cssText = "position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none";
      document.body.appendChild(f);
      var d = f.contentWindow.document;
      d.open(); d.write(buildPrintHtml()); d.close();
      var done = false;
      function go() {
        if (done) return; done = true;
        try { f.contentWindow.focus(); f.contentWindow.print(); }
        catch (e) { flash("Printing isn't available here. Use Save as PDF instead.", 4000); }
        setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 60000);
      }
      var t = setTimeout(go, 1500);
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { clearTimeout(t); setTimeout(go, 200); });
    });

    /* ---------- Events ---------- */
    [el.v1, el.v2].forEach(function (i) {
      i.addEventListener("input", calc);
      i.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); addCurrent(); } });
    });
    el.name.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); addCurrent(); } });
    el.form.addEventListener("submit", function (e) { e.preventDefault(); addCurrent(); });
    el.inunit.addEventListener("change", function () { state.inUnit = el.inunit.value; persist(); renderInputs(); calc(); });
    el.outunit.addEventListener("change", function () { state.outUnit = el.outunit.value; persist(); calc(); });
    [el.r2m, el.m2r].forEach(function (b) {
      b.addEventListener("click", function () {
        var dir = b.getAttribute("data-dir");
        if (state.dir === dir) return;
        state.dir = dir; state.inUnit = DEFAULT_IN[dir]; state.outUnit = DEFAULT_OUT[dir];
        persist(); renderDir(); calc(); el.v1.focus();
      });
    });
    [el.n148, el.n160].forEach(function (b) {
      b.addEventListener("click", function () { state.n = Number(b.getAttribute("data-n")); persist(); renderScales(); calc(); });
    });
    el.save.addEventListener("click", addCurrent);

    /* ---------- Start ---------- */
    var saved = load();
    if (saved) {
      ["scale", "n", "dir", "inUnit", "outUnit"].forEach(function (k) { if (saved[k] != null) state[k] = saved[k]; });
      if (!SCALES[state.scale]) state.scale = "OO";
      if (state.n !== 148 && state.n !== 160) state.n = 148;
      if (state.dir !== "r2m" && state.dir !== "m2r") state.dir = "r2m";
      state.list = Array.isArray(saved.list) ? saved.list : [];
    }
    if (!state.list) {
      state.list = [
        { id: 1, example: true, label: "Mk1 coach body, 64 ft 6 in", dir: "r2m", inText: "64 ft 6 in", outText: fmt((64 * 304.8 + 6 * 25.4) / 76.2, "mm"), scaleText: "OO 1:76.2" },
        { id: 2, example: true, label: "Station platform, 120 m", dir: "r2m", inText: "120 m", outText: fmt(120000 / 148, "mm"), scaleText: "N 1:148" }
      ];
    }
    renderScales(); renderDir();
    if (!saved) el.v1.value = "8";
    calc(); renderList();
  }

  /* ---------- Boot (also re-runs when the Shopify theme editor reloads a section) ---------- */
  function boot() {
    ensureFonts();
    var hosts = document.querySelectorAll("#whww-calc, [data-whww-calc]");
    for (var i = 0; i < hosts.length; i++) init(hosts[i]);
  }
  window.__whwwBoot = boot;
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  boot();
  document.addEventListener("shopify:section:load", boot);
})();